import React, {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";

import {UserContext} from "../../contexts/user";
import {getStaticDataDoc} from "../../utils/staticDataApi";
import {ProfileTippy} from "../styled/Tippy";
import {getInternalPath} from "../../utils/url";

const ProfileMenu = ({user}) => {
  const {userDispatch, logout} = useContext(UserContext);
  const [profileLinks, setProfileLinks] = useState([]);

  let unmounted = false;
  useEffect(() => {
    if (!unmounted) {
      fetchData();
    }

    return () => {
      unmounted = true;
    };
  }, []);

  const fetchData = async () => {
    const doc = await getStaticDataDoc("profile-dropdown", ["links"]);
    if (doc?.links) {
      setProfileLinks(doc.links);
    } else {
      setProfileLinks([]);
    }
  };

  return (
    <ul>
      <li>
        <a href={`https://hackernoon.com/u/${user.handle}`}>@{user.handle}</a>
      </li>

      {profileLinks.map(link => {
        const internalPath = getInternalPath(link.url);
        return (
          <li key={link.name}>
            {internalPath ? <Link to={internalPath}>{link.name}</Link> : <a href={`${link.url}`}>{link.name}</a>}
          </li>
        );
      })}
      <li>
        <button onClick={logout}>Log out</button>
      </li>
    </ul>
  );
};

const ProfileIcon = ({user}) => {
  user.avatar = user.avatar?.replace("https://hackernoon.com", "https://cdn.hackernoon.com");

  return (
    <ProfileTippy content={<ProfileMenu user={user} />} interactive={true}>
      {user.handle ? (
        <a className="profile" href="#">
          <img src={user.avatar} alt="User avatar" />
        </a>
      ) : (
        <a className="profile">
          <img src={user.avatar} alt="User avatar" />
        </a>
      )}
    </ProfileTippy>
  );
};

export default ProfileIcon;
